import { call, put, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import {
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';

import { handleError } from './helper';
import { presentationApi } from '../services';
import {
  PRESENTATIONS_FETCH,
  PRESENTATIONS_FETCH_SUCCESS,
  PRESENTATIONS_FETCH_FAILURE,
  PRESENTATIONS_DELETE_PRESENTATION,
  PRESENTATIONS_DELETE_PRESENTATION_SUCCESS,
  PRESENTATIONS_DELETE_PRESENTATION_FAILURE,
  PRESENTATIONS_SEARCH_SUCCESS,
  PRESENTATIONS_SEARCH_FAILURE,
  PRESENTATIONS_SEARCH,
} from '../reducers/presentations.reducer';

function* fetchPresentationsRequest() {
  try {
    yield put({ type: LOADING_DATA_START });
    const result = yield call(presentationApi.fetchPresentations);
    yield put({
      type: PRESENTATIONS_FETCH_SUCCESS,
      payload: result.data,
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: PRESENTATIONS_FETCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* searchPresentationsRequest({ payload: { query } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield call(delay, 1000);
    const result = yield call(presentationApi.searchPresentations, { query });
    yield put({
      type: PRESENTATIONS_SEARCH_SUCCESS,
      payload: result.data,
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: PRESENTATIONS_SEARCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* deletePresentationRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield call(presentationApi.deletePresentation, { id });
    yield put({
      type: PRESENTATIONS_DELETE_PRESENTATION_SUCCESS,
      payload: { id },
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({
      type: PRESENTATIONS_DELETE_PRESENTATION_FAILURE,
      payload: message,
    });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* fetchPresentations() {
  yield takeLatest(PRESENTATIONS_FETCH, fetchPresentationsRequest);
}

export function* searchPresentations() {
  yield takeLatest(PRESENTATIONS_SEARCH, searchPresentationsRequest);
}

export function* deletePresentation() {
  yield takeLatest(
    PRESENTATIONS_DELETE_PRESENTATION,
    deletePresentationRequest
  );
}



// WEBPACK FOOTER //
// ./src/sagas/presentations.saga.js